module.exports = __webpack_public_path__ + "static/img/bg_t.e14d048.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/feedFlarePage/bg_t.png
// module id = PfVo
// module chunks = 1